import { usePaymentDetail } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/PaymentDetailContext';
import { ApplicationContent } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/ApplicationContent';
import { TransactionsDetailSection } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail';
import { Loading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, Suspense } from 'react';
import { BasicInfoSection } from './BasicInfoSection';
import { useApprovingInvoiceReportSummaryData } from './hooks';
import { JournalInfo } from './JournalInfo';
import styles from './styles.module.scss';
import { FooterAction } from './FooterAction';
const cx = classnames.bind(styles);

type LeftContentProps = {
  id: string;
  onClose: () => void;
};

const InnerLeftContent: FC<LeftContentProps> = ({ id, onClose }) => {
  const { data } = useApprovingInvoiceReportSummaryData(id, onClose);
  const { isRightPaneCollapsed, titleInfo } = usePaymentDetail();

  return (
    <div className={cx('left-content', { 'full-width': isRightPaneCollapsed })}>
      <BasicInfoSection data={data} />
      <ApplicationContent reportId={id} />
      <TransactionsDetailSection reportId={id} />
      <JournalInfo reportId={id} />
      <FooterAction
        is_report_approval={titleInfo?.is_report_approval}
        is_approvable={titleInfo?.is_approvable}
        reportId={id}
      />
    </div>
  );
};

const FallBackLoading = () => {
  return (
    <div className={cx('loading-container')}>
      <Loading size='large' color='default' />
    </div>
  );
};

export const LeftContent: FC<LeftContentProps> = memo((props) => {
  return (
    <Suspense fallback={<FallBackLoading />}>
      <InnerLeftContent {...props} />
    </Suspense>
  );
});

LeftContent.displayName = 'LeftContent';
